var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusXl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C11.8679 0 12.5714 0.703552 12.5714 1.57143V9.42857H20.4286C21.2964 9.42857 22 10.1321 22 11C22 11.8679 21.2964 12.5714 20.4286 12.5714H12.5714V20.4286C12.5714 21.2964 11.8679 22 11 22C10.1321 22 9.42857 21.2964 9.42857 20.4286V12.5714H1.57143C0.703552 12.5714 0 11.8679 0 11C0 10.1321 0.703553 9.42857 1.57143 9.42857H9.42857V1.57143C9.42857 0.703552 10.1321 0 11 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusXl);
export default __webpack_public_path__ + "static/media/plus-xl.c1cb9816a6cae391cc43ac2c7493c074.svg";
export { ForwardRef as ReactComponent };